export default "__VITE_ASSET__BioqEwlz__"